module.exports = __webpack_public_path__ + "img/34.4e4e5472.png";